import { MessageRetailerOrBrandButton, additionalDataRequiredForContactingRetailerOrBrandCTA } from "../../shared/instantAnswerUtils";
import { getDeliveredAtDateFromIAContext } from "../../utils/getDeliveredAtDateFromIAContext";
import { orderCanBeReportedBasedOnDeliveryDate } from "../../utils/orderCanBeReportedBasedOnDeliveryDate";
import { DO_NOT_PROCESS_DAMAGED_AS_RETURN, getReportItemsOrRequestExtensionCTA } from "./shared";
export var ReportDamagedMissingItemsOrShipmentsIA = function ReportDamagedMissingItemsOrShipmentsIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getReportItemsOrRequ;
        return (_getReportItemsOrRequ = getReportItemsOrRequestExtensionCTA(context, strictLocalize)) === null || _getReportItemsOrRequ === void 0 ? void 0 : _getReportItemsOrRequ.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getReportItemsOrRequ2, _getReportItemsOrRequ3;
        return (_getReportItemsOrRequ2 = getReportItemsOrRequestExtensionCTA(context, strictLocalize)) === null || _getReportItemsOrRequ2 === void 0 ? void 0 : (_getReportItemsOrRequ3 = _getReportItemsOrRequ2.getLink) === null || _getReportItemsOrRequ3 === void 0 ? void 0 : _getReportItemsOrRequ3.call(_getReportItemsOrRequ2, context.brandOrder);
      }
    },
    secondaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _MessageRetailerOrBra;
        return (_MessageRetailerOrBra = MessageRetailerOrBrandButton(context, strictLocalize)) === null || _MessageRetailerOrBra === void 0 ? void 0 : _MessageRetailerOrBra.label;
      },
      onClickFunctionBuilder: function onClickFunctionBuilder(context) {
        var _MessageRetailerOrBra2;
        return (_MessageRetailerOrBra2 = MessageRetailerOrBrandButton(context, strictLocalize)) === null || _MessageRetailerOrBra2 === void 0 ? void 0 : _MessageRetailerOrBra2.onClick;
      }
    },
    additionalRequiredData: additionalDataRequiredForContactingRetailerOrBrandCTA()
  };
};
var getAnswer = function getAnswer(context, strictLocalize) {
  var brandOrder = context.brandOrder,
    shippingContext = context.shippingContext;
  var deliveredAt = getDeliveredAtDateFromIAContext(context);
  if (!brandOrder || !shippingContext || !deliveredAt) {
    return NO_ORDER_OR_DELIVERY_AVAILABLE_CASE(strictLocalize);
  }
  if (orderCanBeReportedBasedOnDeliveryDate(deliveredAt)) {
    return REPORT_PERIOD_IS_ACTIVE_CASE(strictLocalize);
  }
  return REPORT_PERIOD_IS_OVER_CASE(strictLocalize);
};
var NO_ORDER_OR_DELIVERY_AVAILABLE_CASE = function NO_ORDER_OR_DELIVERY_AVAILABLE_CASE(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return REPORTING_DAMAGED_OR_MISSING_ITEMS(strictLocalize);
    },
    getDescription: function getDescription() {
      return [REPORTING_DAMAGED_OR_MISSING_ITEMS_FULL_EXPLANATION(strictLocalize), DO_NOT_PROCESS_DAMAGED_AS_RETURN(strictLocalize)];
    }
  };
};
var REPORTING_DAMAGED_OR_MISSING_ITEMS = function REPORTING_DAMAGED_OR_MISSING_ITEMS(strictLocalize) {
  return strictLocalize({
    id: "g4pIkR",
    defaultMessage: [{
      "type": 0,
      "value": "Beschadigde of ontbrekende artikelen melden"
    }]
  });
};
var REPORTING_DAMAGED_OR_MISSING_ITEMS_FULL_EXPLANATION = function REPORTING_DAMAGED_OR_MISSING_ITEMS_FULL_EXPLANATION(strictLocalize) {
  return strictLocalize({
    id: "p/vZQt",
    defaultMessage: [{
      "type": 0,
      "value": "Als de bestelling minder dan 14 dagen geleden is geleverd, kun je het merk rechtstreeks een bericht sturen over je beschadigde of ontbrekende artikelen of een beschadigd of vermist artikel melden via de onderstaande knop. Als de bestelling meer dan 14 dagen geleden is geleverd, is de periode waarbinnen je de artikelen kunt melden voorbij. Je kunt een verlenging aanvragen als er sprake is van uitzonderlijke omstandigheden."
    }]
  });
};
var REPORT_PERIOD_IS_ACTIVE_CASE = function REPORT_PERIOD_IS_ACTIVE_CASE(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return REPORTING_DAMAGED_OR_MISSING_ITEMS(strictLocalize);
    },
    getDescription: function getDescription() {
      return [MESSAGE_BRAND(strictLocalize)];
    }
  };
};
var MESSAGE_BRAND = function MESSAGE_BRAND(strictLocalize) {
  return strictLocalize({
    id: "hrxZcm",
    defaultMessage: [{
      "type": 0,
      "value": "Je kunt het merk rechtstreeks een bericht sturen over je beschadigde of vermiste artikelen of een beschadigd of vermist artikel melden via de onderstaande knop."
    }]
  });
};
var REPORT_PERIOD_IS_OVER_CASE = function REPORT_PERIOD_IS_OVER_CASE(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return REPORT_PERIOD_IS_OVER(strictLocalize);
    },
    getDescription: function getDescription() {
      return [MESSAGE_BRAND_TO_LEARN_MORE(strictLocalize), DO_NOT_PROCESS_DAMAGED_AS_RETURN(strictLocalize)];
    }
  };
};
var REPORT_PERIOD_IS_OVER = function REPORT_PERIOD_IS_OVER(strictLocalize) {
  return strictLocalize({
    id: "n7EUbR",
    defaultMessage: [{
      "type": 0,
      "value": "Je periode van 14 dagen om beschadigde of ontbrekende artikelen voor deze bestelling te melden is verstreken."
    }]
  });
};
var MESSAGE_BRAND_TO_LEARN_MORE = function MESSAGE_BRAND_TO_LEARN_MORE(strictLocalize) {
  return strictLocalize({
    id: "QzeAQm",
    defaultMessage: [{
      "type": 0,
      "value": "Je kunt het merk een bericht sturen om meer te weten te komen over de beschadigde of ontbrekende artikelen of een verlenging aanvragen als er sprake is van uitzonderlijke omstandigheden."
    }]
  });
};